<template>
  <div class="view match" style="overflow-x: scroll;">
    <component :is="activeView" />
  </div>
</template>

<script>
export default {
  computed: {
    activeView() {
      // Get status of the Match
      const isOngoing = this.$store.state.isGameOver;
      const isOnBreak = this.$store.state.isOnBreak;
      const mystery = this.$store.state.mystery;
      const spin = this.$store.state.has_spin;
      const slide = this.$store.state.has_video;

      if (!isOngoing)
        return () => import("../components/Prequiz.vue");

      if(isOnBreak) {
        if (this.$store.state.has_game === 'tic_tac_toe') {
          return () => import("../components/TicTacToe.vue");
        }
        if (this.$store.state.has_game === '1_to_25') {
          return () => import("../components/1to50.vue");
        }
        if (this.$store.state.matchSlug ==628) {
          if (this.$store.state.round == 3) {
            if (spin) {
              return () => import("../components/SpinTheWheel.vue");
            }
          }
        }

        if (slide) {
          return () => import("../components/video.vue");
        }

      }

      if(mystery)
        return () => import("../components/MysteryBoxes.vue");

      return () => import("../components/Quiz.vue");
    }
  }
};
</script>

<style lang="sass" scoped>
.match
  display: grid
  grid-template-rows: auto
</style>
